import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-pagamenti',
  templateUrl: './pagamenti.component.html',
  styleUrls: ['./pagamenti.component.css'],

})
export class PagamentiComponent implements OnInit {

  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;

  data: any[] = [];

  statusSuccess: string;

  constructor(private dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.statusSuccess = this.route.snapshot.queryParamMap.get("success");

    this.isLoadingResults = true;
    this.dataService.pagamenti
      .pipe(
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.length;
          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return of([]);
        })
      ).subscribe(data => {
        this.data = data;
      });
  }

}
